import { makeAutoObservable, runInAction } from 'mobx';
import {
  IFinanceReport,
  IFinanceReportParams,
} from 'src/@types/Choqorak/MainTables/Finance/FinanceReport';
import agent from 'src/api/agent';
export default class FinanceReportStore {
  openDialog = false;

  FinanceReportRegistry = new Map<number, IFinanceReport>();

  editMode = false; //When click on edit button

  selectedFinanceReport: IFinanceReport | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get FinanceReportList() {
    return Array.from(this.FinanceReportRegistry.values());
  }

  setFinanceReportList = (FinanceReport: IFinanceReport) => {
    this.FinanceReportRegistry.set(FinanceReport.id!, FinanceReport);
  };

  //Pagination
  loadFinanceReport = async (params: IFinanceReportParams) => {
    // this.FinanceReportRegistry.clear();
    try {
      const result = await agent.FinanceReport.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setFinanceReportList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  FinanceReportSearch = async (params: IFinanceReportParams) => {
    //this.FinanceReportRegistry.clear();
    this.loadFinanceReport(params);
  };

  getFinanceReportFromRegistry = (id: number) => {
    let FinanceReport = this.FinanceReportRegistry.get(id);
    if (FinanceReport) {
      this.editMode = true;
      this.selectedFinanceReport = FinanceReport;
    }
  };

  clearSelectedFinanceReport = () => {
    this.editMode = false;
    this.selectedFinanceReport = undefined;
  };

  deleteFinanceReport = async (id: number, remark?: string) => {
    try {
      await agent.FinanceReport.delete(id, remark!);
      runInAction(() => {
        this.FinanceReportRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createFinanceReport = async (FinanceReport: IFinanceReport) => {
    try {
      await agent.FinanceReport.create(FinanceReport);
      runInAction(() => {
        this.loadFinanceReport({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedFinanceReport();
      });
    } catch (error) {
      console.log(error);
    }
  };

  updateFinanceReport = async (FinanceReport: IFinanceReport) => {
    try {
      await agent.FinanceReport.update(FinanceReport);

      runInAction(() => {
        this.loadFinanceReport({ pageIndex: 0, pageSize: 5 });
        this.FinanceReportRegistry.delete(FinanceReport.id!);
        this.FinanceReportRegistry.set(FinanceReport.id!, FinanceReport);
        this.clearSelectedFinanceReport();
      });
    } catch (error) {
      console.log(error);
    }
  };
}
